import { observer } from "mobx-react-lite";
import MainLayout from "../MainLayout";
import { useNavigate } from "react-router-dom";
import { HorizontalLayout, VerticalLayout } from "../../common/common-layout";
import { TitleLargeMedium, TitleMediumBold, TitleNormal, TitleNormalBold } from "../../common/common-text";
import BTBox from "../../common/components/BTBox";
import BTInputBox from "../../common/components/BTInputBox";
import BTButton from "../../common/components/BTButton";
import theme from '../../common/theme';
import { dialogStore } from '../../store/DialogStore';
import { useEffect, useState } from "react";
import { fetchContactPersons, updateContactPerson } from "../../common/firebase/Firestore";
import ContactPerson from "../../model/homepage/ContactPerson";
import { MAIN_RIGHT_TOP_HEIGHT } from "../MainLayout";

const ContactPersons = () => {
    return (
        <MainLayout>
            <ContactPersonsBody />
        </MainLayout>
    );
};

export default ContactPersons;

const ContactPersonsBody = observer(() => {
    const navigate = useNavigate();
    const [contactPersons, setContactPersons] = useState<ContactPerson[]>([]);
    const [originalContactPersons, setOriginalContactPersons] = useState<ContactPerson[]>([]);

    useEffect(() => {
        const loadContacts = async () => {
            const data = await fetchContactPersons();
            setContactPersons(data);
            setOriginalContactPersons(data);
        };
        loadContacts();
    }, []);

    const updateField = (id: string, field: any, value: any) => {
        setContactPersons(prev => prev.map(c => c.id === id ? { ...c, [field]: value } : c));
    };

    const isChanged = (original: ContactPerson, current: ContactPerson): boolean => {
        return original.name !== current.name || original.email !== current.email;
    };

    const handleSave = async () => {
        dialogStore.showDialog({
            title: '알림',
            message: '정말 저장하시겠습니까?',
            onConfirm: async () => {
                try {
                    for (const current of contactPersons) {
                        const original = originalContactPersons.find(o => o.id === current.id);
                        // 변경된 건만 갱신
                        if (current.id && original && isChanged(original, current)) {
                            await updateContactPerson(current.id, { ...current, updatedAt: new Date() });
                        }
                    }
                    dialogStore.showDialog({
                        title: '성공',
                        message: '저장되었습니다.',
                        onConfirm: () => {},
                    });
                } catch (error) {
                    dialogStore.showDialog({
                        title: '에러',
                        message: '저장 중 오류가 발생했습니다.',
                        onConfirm: () => {},
                    });
                }
            },
            onCancel: () => { },
        });
    };

    return (
        <div style={{ width: '100%', minHeight: `calc(100vh - ${MAIN_RIGHT_TOP_HEIGHT})`, display: 'flex', flexDirection: 'column' }}>
            <VerticalLayout height={'auto'} paddingLeft={36} paddingRight={36}>
              <TitleLargeMedium>담당자 관리</TitleLargeMedium>
              <BTBox height='24px' />

              {
                  contactPersons.map((contactPerson) => (
                      contactPerson.id ?
                        <div key={contactPerson.workname} style={{ width: '678px', marginBottom: '32px' }}>
                          <TitleMediumBold>{contactPerson.workname}</TitleMediumBold>
                          <BTBox height='16px' />

                          <TitleNormal color='#8a92a6'>담당자명</TitleNormal>
                          <BTBox height='8px' />
                          <BTInputBox
                            value={contactPerson.name || ''}
                            onChange={(e) => updateField(contactPerson.id!, 'name', e.target.value)}
                          />

                          <BTBox height='16px' />
                          <TitleNormal color='#8a92a6'>담당자 이메일</TitleNormal>
                          <BTBox height='8px' />
                          <BTInputBox
                            value={contactPerson.email || ''}
                            onChange={(e) => updateField(contactPerson.id!, 'email', e.target.value)}
                          />
                      </div>
                      :
                      <div />
                  ))
              }
            </VerticalLayout>

            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', paddingRight: '76px', paddingBottom: '76px' }}>
                <HorizontalLayout style={{ marginTop: 'auto', justifyContent: 'flex-end' }}>
                    <BTButton color={theme.colors.bbTech} textColor='white' onClick={handleSave}>저장</BTButton>
                </HorizontalLayout>
            </div>
        </div>
    );
});
